import styled from '@emotion/styled';
import { StyledProps as Props, Theme } from './Grid.types';
import facepaint from 'facepaint';
import { space } from 'styled-system';

const media = (theme: Theme): string[] => theme.screenSizes.map((size) => `@media(min-width: ${size}px)`);
const gutters = (theme: Theme): string[] => theme.grid.gutter.screenSizes.map((width) => `${width}px`);

export default styled.div<Props, Theme>`
  ${(props) =>
    facepaint(media(props.theme))({
      display: 'grid',
      columnGap: props.columnGap
        ? `${props.theme.space[props.columnGap]}px`
        : [props.theme.grid.gutter.default, ...gutters(props.theme)],
    })}
  
  ${({ cols }) => cols && { gridTemplateColumns: `repeat(${cols ? cols : 12}, 1fr)` }}
  
  ${({ flow }) => flow && { gridAutoFlow: flow }}

  ${({ autoColumns }) => autoColumns && { gridAutoColumns: autoColumns }}
   
  ${space}
`;
